import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { rolPatch } from "../../store/rol/actions";
export var useRolPatch = function (trigger, body, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseRolPatch: state.Rol.responseRolPatch,
        errorRolPatch: state.Rol.errorRolPatch,
        loadingRolPatch: state.Rol.loadingRolPatch,
    }); }), responseRolPatch = _a.responseRolPatch, errorRolPatch = _a.errorRolPatch, loadingRolPatch = _a.loadingRolPatch;
    useEffect(function () {
        if (trigger && body && id) {
            dispatch(rolPatch({
                name: body.name,
                description: body.description,
                permissions: body.permissions || [],
            }, id));
        }
    }, [trigger, body, id, dispatch]);
    return {
        responseRolPatch: responseRolPatch,
        errorRolPatch: errorRolPatch,
        loadingRolPatch: loadingRolPatch,
    };
};
